export default __webpack_public_path__ + "static/media/home-bible.ae017159.jpg";